import React from "react"
import styled from "styled-components/macro"
import { PageMargin } from "../../GlobalStyles"
import colors from "../../scripts/colors"
import "@fontsource/noto-sans-jp/700.css"

type PropTypes = {
  info: any
  logoObj: { logoIconImage: string; logoTextImage: string }
}
const currYear = new Date()

const FooterStyles = styled.footer`
  background-color: ${colors("grey", "dk")};
  padding-bottom: 40px;
  margin-top: 125px;
`

const FooterPageMargin = styled(PageMargin)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  @media screen and (min-width: 1500px) {
    flex-direction: row;
    align-items: flex-end;
  }
`

const SiteInfo = styled.section`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  margin-bottom: 25px;
  @media screen and (min-width: 500px) {
    flex-direction: row;
  }
  @media screen and (min-width: 1500px) {
    width: auto;
    margin-bottom: 0;
  }
`

const FooterIconWrap = styled.section``

const FooterIcon = styled.img`
  margin-top: -60px;
  margin-left: -5px;
`

const FooterInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 18px 0 0 8px;
  font-family: "Noto Sans JP", sans-serif;
  width: 100%;
  @media screen and (min-width: 790px) {
    flex-direction: row;
  }
  @media screen and (min-width: 1500px) {
    flex-direction: column;
  }
`

const FooterTextLogo = styled.img`
  margin-bottom: 30px;
  margin-right: 25px;
  flex: 0 0 auto;
  @media screen and (min-width: 1500px) {
    margin-right: 0;
  }
`

const FooterInfo = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  p {
    margin: 0;
    font-size: 20px;
    color: white;
    &:first-child {
      margin-bottom: 20px;
    }
    &:last-child {
      margin-top: 0;
      margin-left: 0;
    }
  }
  @media screen and (min-width: 1024px) {
    flex-direction: row;
    p:last-child {
      margin-left: 50px;
    }
  }
  @media screen and (min-width: 1500px) {
    display: block;
    flex-direction: row;
    p:last-child {
      margin-top: 22px;
      margin-left: 0;
    }
  }
`

const SiteDisclaimer = styled.div`
  width: 100%;
  @media screen and (min-width: 1500px) {
    width: 615px;
  }
`

const FooterDisclaimer = styled.p`
  color: white;
  font-size: 16px;
  margin: 0 0 40px;
`

const FooterCopy = styled.p`
  color: white;
  font-size: 15px;
  text-transform: uppercase;
  font-family: "Noto Sans JP", sans-serif;
  font-weight: 700;
  margin: 0;
`

const Footer: React.FC<PropTypes> = ({ info, metaData }) => {
  const { streetAddress, city, state, zip, phone } = info.facilityInfo
  return (
    <FooterStyles id="SiteFooter" role="contentinfo">
      <FooterPageMargin>
        <SiteInfo>
          <FooterIconWrap>
            <FooterIcon
              loading="lazy"
              src={`https://res.cloudinary.com/agoraservices/w_147,q_auto,f_auto/${metaData.logoIconImageId}`}
              alt={`${info.facilityName} logo icon`}
            />
          </FooterIconWrap>
          <FooterInfoWrap>
            <FooterTextLogo
              loading="lazy"
              src={`https://res.cloudinary.com/agoraservices/w_227,co_white,e_colorize:100,q_auto,f_auto/${metaData.logoTextImageId}`}
              alt={`${info.facilityName} logo text`}
            />
            <FooterInfo role="region">
              <p>{phone}</p>
              <p>
                {streetAddress}
                <br />
                {city} {state}, {zip}
              </p>
            </FooterInfo>
          </FooterInfoWrap>
        </SiteInfo>
        <SiteDisclaimer>
          <section role="region">
            <FooterDisclaimer>
              *EOE AA M/F/Vet/Disability: Qualified applicants will receive
              consideration for employment without regard to their race, color,
              religion, national origin, sex, sexual orientation, gender
              identity, protected veteran status or disability.
            </FooterDisclaimer>
          </section>
          <section role="region">
            <FooterCopy>
              &copy; {currYear.getFullYear()} {info.facilityName}
            </FooterCopy>
          </section>
        </SiteDisclaimer>
      </FooterPageMargin>
    </FooterStyles>
  )
}

export default Footer
